import React from "react";
import MobileViewGlobal from "../../../Views/MobileView";
import ActionListItem from "./ActionListItem";
import HTMLRenderer from "../../../library/HTMLRenderer";
import hasContent from "../../../../util/hasContent";

export default function ActionListMobile({ actionPoints, actionInfo }) {
  const { header, description } = actionInfo;

  const infoNoHeaderStyle = {
    marginBottom: header || description ? "16px" : "0px",
    // marginTop: "16px",
    padding: header || description ? "16px" : "0px",
  };

  function getSortedActionPointList() {
    if (!actionPoints) return [];
    // return actionPoints.sort((a, b) => a.order - b.order);
    return actionPoints
      .sort((a, b) => b.id - a.id)
      .sort((a, b) => a.order - b.order);
  }

  return (
    <MobileViewGlobal
      className="actionlist__wrapper"
      style={{ marginTop: !header || !description ? "16px" : "0px" }}
    >
      {(header || hasContent(description)) && (
        <div className="actionInfo" style={infoNoHeaderStyle}>
          {header && <h4>{header}</h4>}
          {hasContent(description) && <HTMLRenderer html={description} />}
        </div>
      )}
      {getSortedActionPointList().map((item, index) => {
        return <ActionListItem key={index} {...item} />;
      })}
    </MobileViewGlobal>
  );
}
